import { Flex } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { useAppContext } from "../context/appContext/appContext";
import { ProfileMenu } from "./index.js";

const NavLinks = ({ direction, active, notActive, signInColor, close }) => {
  const { user } = useAppContext();

  return (
    <Flex gap={9} align="center" fontSize={20} direction={direction}>
      <NavLink
        className="link"
        onClick={close}
        to="/"
        style={({ isActive }) => ({
          color: isActive ? active : notActive,
          fontWeight: isActive ? "bold" : "",
        })}
      >
        Home
      </NavLink>
      <NavLink
        className="link"
        onClick={close}
        to="/about"
        style={({ isActive }) => ({
          color: isActive ? active : notActive,
          fontWeight: isActive ? "bold" : "",
        })}
      >
        About
      </NavLink>
      <NavLink
        className="link"
        onClick={close}
        to="/rules"
        style={({ isActive }) => ({
          color: isActive ? active : notActive,
          fontWeight: isActive ? "bold" : "",
        })}
      >
        Rules
      </NavLink>
      <NavLink
        className="link"
        onClick={close}
        to="/strategy"
        style={({ isActive }) => ({
          color: isActive ? active : notActive,
          fontWeight: isActive ? "bold" : "",
        })}
      >
        Strategy
      </NavLink>
      <NavLink
        className="link"
        onClick={close}
        to="/practice"
        style={({ isActive }) => ({
          color: isActive ? active : notActive,
          fontWeight: isActive ? "bold" : "",
        })}
      >
        Practice
      </NavLink>
      <NavLink
        className="link"
        onClick={close}
        to="/play"
        style={({ isActive }) => ({
          color: isActive ? active : notActive,
          fontWeight: isActive ? "bold" : "",
        })}
      >
        Play
      </NavLink>
      <NavLink
        className="link"
        onClick={close}
        to="/standings"
        style={({ isActive }) => ({
          color: isActive ? active : notActive,
          fontWeight: isActive ? "bold" : "",
        })}
      >
        Standings
      </NavLink>
      {user ? (
        <ProfileMenu />
      ) : (
        <NavLink
          className="link"
          onClick={close}
          to="/register"
          style={{ color: signInColor, fontStyle: "italic" }}
        >
          Sign In / Register
        </NavLink>
      )}
    </Flex>
  );
};
export default NavLinks;
